const HEADER_NAME = "x-breaking-changes-count";
const STORAGE_KEY = "breaking-changes-count";

let knownCount: string | null = localStorage.getItem(STORAGE_KEY);
let breakingChangesDetected = false;

export function hasBreakingChanges(): boolean {
  return breakingChangesDetected;
}

export function resetBreakingChangesState(): void {
  knownCount = localStorage.getItem(STORAGE_KEY);
  breakingChangesDetected = false;
}

export function createBreakingChangesFetch(
  baseFetch: typeof fetch,
): typeof fetch {
  return async (input, init?) => {
    const response = await baseFetch(input, init);

    const count = response.headers.get(HEADER_NAME);
    if (count !== null) {
      if (knownCount === null) {
        knownCount = count;
        localStorage.setItem(STORAGE_KEY, count);
      } else if (count !== knownCount) {
        breakingChangesDetected = true;
        knownCount = count;
        localStorage.setItem(STORAGE_KEY, count);
      }
    }

    return response;
  };
}
